import apis from ".";

export const SellerRegister = async (sellerProfile, accessToken) => {
  try {
    // Log the FormData contents

    const newformdata = new FormData();

    for (let [key, value] of sellerProfile.entries()) {
      newformdata.append(key, value);
    }
    console.log(typeof newformdata);
    const result = await apis.post("/register-as-seller", newformdata, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return result;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};
